(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/set-deposit-limits-form.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/set-deposit-limits-form.js');
'use strict';

const {
  logger
} = svs.accountservicesReact;
const {
  useState
} = React;
const {
  Form,
  ControlGroup
} = svs.ui.reactForm;
const {
  Currency: formatCurrency
} = svs.utils.format;
const AmountInput = svs.ui.reactFormInputs.AmountInput;
const Button = svs.ui.ReactButton;
const SetDepositLimitsForm = _ref => {
  let {
    isUnderTwenty,
    dayLimit,
    infoMessage,
    monthLimit,
    setDayLimit,
    onDone,
    setMonthLimit,
    setWeekLimit,
    weekLimit
  } = _ref;
  const [fieldLimitErrors, setFieldLimitErrors] = useState({});
  const [formValidationErrors, setFormValidationErrors] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
  let maxRange = isUnderTwenty ? 1000 : 10000;
  if (svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE)) {
    maxRange = 1000000;
  }
  const minRange = 25;
  const periods = {
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month'
  };

  const createInfoMessage = period => {
    const limitsMedianValues = {
      [periods.DAY]: '500',
      [periods.WEEK]: '500',
      [periods.MONTH]: '1000'
    };
    const limitsPeriodText = {
      [periods.DAY]: 'dag',
      [periods.WEEK]: 'vecka',
      [periods.MONTH]: 'månad'
    };
    return "".concat(formatCurrency(limitsMedianValues[period]), " kr per ").concat(limitsPeriodText[period], " \xE4r en vanlig gr\xE4ns hos v\xE5ra kunder");
  };
  const isNumeric = str => {
    if (typeof str != 'string') {
      return false;
    }
    return !isNaN(str) && !isNaN(parseFloat(str)); 
  };

  const validateAllAmountFormattings = () => !isNumeric(dayLimit) || !isNumeric(weekLimit) || !isNumeric(monthLimit);

  const parseFloatOrZero = value => parseFloat(value) || 0;

  const validateAllLimitSizes = () => {
    const newErrorObject = {};
    const dayLimitNumber = parseFloatOrZero(dayLimit);
    const weekLimitNumber = parseFloatOrZero(weekLimit);
    const monthLimitNumber = parseFloatOrZero(monthLimit);
    if (weekLimitNumber > monthLimitNumber) {
      newErrorObject.weekLimit = 'Din veckogräns kan inte vara högre än din månadsgräns,';
    }
    if (dayLimitNumber > weekLimitNumber && dayLimitNumber > monthLimitNumber) {
      newErrorObject.dayLimit = 'Din dagsgräns kan inte vara högre än din månads- och veckogräns.';
    } else {
      if (dayLimitNumber > monthLimitNumber) {
        newErrorObject.dayLimit = 'Din dagsgräns kan inte vara högre än din månadsgräns.';
      }
      if (dayLimitNumber > weekLimitNumber) {
        newErrorObject.dayLimit = 'Din dagsgräns kan inte vara högre än din veckogräns.';
      }
    }
    setFieldLimitErrors(newErrorObject);
    return Boolean(Object.keys(newErrorObject).length);
  };

  const onValidateHandler = (name, isValid, errorMessage) => {
    if (!isValid) {
      const filteredErrors = [...formValidationErrors.filter(err => err.id !== name)];
      setFormValidationErrors([...filteredErrors, {
        id: name,
        error: errorMessage
      }]);
    } else {
      setFormValidationErrors(formValidationErrors.filter(err => err.id !== name));
    }
  };
  const isValidRange = () => parseFloat(dayLimit) >= minRange && parseFloat(dayLimit) <= maxRange && parseFloat(weekLimit) >= minRange && parseFloat(weekLimit) <= maxRange && parseFloat(monthLimit) >= minRange && parseFloat(monthLimit) <= maxRange;
  const onSubmitHandler = async e => {
    e.preventDefault();
    if (formValidationErrors.length) {
      logger.debug('has form validation errors: ', formValidationErrors);
      return;
    }
    const hasFormattingErrors = validateAllAmountFormattings();
    if (hasFormattingErrors) {
      logger.debug('has formatting errors: ', hasFormattingErrors);
      return;
    }
    const hasLimitErrors = validateAllLimitSizes();
    if (hasLimitErrors) {
      logger.debug('has limit errors:', hasLimitErrors);
      return;
    }
    const hasValidRange = isValidRange();
    if (!hasValidRange) {
      return;
    }
    if (isButtonDisabled) {
      return;
    }
    setIsButtonDisabled(true);
    onDone();
    setIsButtonDisabled(false);
  };
  const errorMessageMin = () => "Den l\xE4gsta gr\xE4nsen du kan s\xE4tta \xE4r ".concat(formatCurrency(minRange), " kr.");
  const errorMessageMax = () => "Den h\xF6gsta gr\xE4nsen du kan s\xE4tta nu \xE4r ".concat(formatCurrency(maxRange), " kr.").concat(isUnderTwenty ? '' : ' Om du behöver höja gränsen kan du göra det senare i Mina gränser.');
  return React.createElement(Form, {
    className: "margin-h-0",
    onSubmit: onSubmitHandler,
    onValidate: onValidateHandler,
    setError: fieldLimitErrors
  }, React.createElement(ControlGroup, {
    infoMessage: createInfoMessage(periods.MONTH),
    isLessSpace: true,
    v2: true
  }, React.createElement(AmountInput, {
    errorMessageDefault: "Ange beloppet med hela siffror.",
    errorMessageMax: errorMessageMax(),
    errorMessageMin: errorMessageMin(),
    errorMessageRequired: "Du m\xE5ste ange m\xE5nadsgr\xE4ns",
    isLessSpace: true,
    label: "Ins\xE4ttningsgr\xE4ns per m\xE5nad",
    max: maxRange,
    min: minRange,
    name: "monthLimit",
    onChange: e => setMonthLimit(e.target.value),
    value: monthLimit
  })), React.createElement(ControlGroup, {
    infoMessage: createInfoMessage(periods.WEEK),
    isLessSpace: true,
    v2: true
  }, React.createElement(AmountInput, {
    errorMessageDefault: "Ange beloppet med hela siffror.",
    errorMessageMax: errorMessageMax(),
    errorMessageMin: errorMessageMin(),
    errorMessageRequired: "Du m\xE5ste ange veckogr\xE4ns",
    isLessSpace: true,
    label: "Ins\xE4ttningsgr\xE4ns per vecka",
    max: maxRange,
    min: minRange,
    name: "weekLimit",
    onChange: e => setWeekLimit(e.target.value),
    value: weekLimit
  })), React.createElement(ControlGroup, {
    infoMessage: createInfoMessage(periods.DAY),
    isLessSpace: true,
    v2: true
  }, React.createElement(AmountInput, {
    errorMessageDefault: "Ange beloppet med hela siffror.",
    errorMessageMax: errorMessageMax(),
    errorMessageMin: errorMessageMin(),
    errorMessageRequired: "Du m\xE5ste ange dagsgr\xE4ns",
    isLessSpace: true,
    label: "Ins\xE4ttningsgr\xE4ns per dag",
    max: maxRange,
    min: minRange,
    name: "dayLimit",
    onChange: e => setDayLimit(e.target.value),
    value: dayLimit
  })), infoMessage && React.createElement("div", {
    className: "margin-top-2"
  }, infoMessage), React.createElement(Button, {
    block: true,
    className: "margin-top-2 margin-bottom-1",
    disabled: isButtonDisabled,
    focus: true,
    type: "submit"
  }, "Forts\xE4tt"));
};
svs.accountservicesReact.gameLimitDepositsForm.SetDepositLimitsForm = SetDepositLimitsForm;

 })(window);